import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../../../../core/services/user.service';
import { Users } from '../../../../core/models/users';
import { SyncConfigService } from '../../../../core/services/sync-config.service';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { interval, Subscription } from 'rxjs';
import { HeaderService } from '../../../../core/services/header.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NodeService } from './../../../../core/services/node.service';
import { Node } from 'src/app/core/models/node';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'app-scale-confirmation',
  templateUrl: './scale-confirmation.component.html',
  styleUrls: ['./scale-confirmation.component.scss']
})
export class ScaleConfirmationComponent implements OnInit {

  user: string;
  loggedUserData: Users;
  isLicenseExpired: boolean = false;
  userWalletAmount: number;
  toShow;
  reloadNotificationData: Subscription;
  reloadUserWallet: Subscription;
  nodeDataRequestSub: Subscription;
  role: string = "";
  depName;
  tempVmName; //temporary
  nodes: Node[];
  autoScaleActive: boolean = false;


  title: string = this.data.title;
  message: string = this.data.message;
  constructor(
    private userService: UserService,
    private syncConfig: SyncConfigService,
    private authenticationService: AuthenticationService,
    private headerService: HeaderService,
    private _snackBar: MatSnackBar,
    private nodeService: NodeService,
    private route: ActivatedRoute,
    private router: Router,

    public dialog: MatDialogRef<ScaleConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      deployment: string;
      title: string;
      message: string;
      cores: number;
    },
  ) { }

  ngOnInit() {
    this.depName = this.data?.deployment;
    this.authenticationService.currentUser.subscribe((user) => {
      if (user == null) {
        this.toShow = false;
        if (this.reloadNotificationData) this.reloadNotificationData.unsubscribe();
      } else {
        this.toShow = true;
        this.user = user.username
        this.role = this.authenticationService.getRole() || "";
        
        this.reloadUserWallet = interval(this.syncConfig.config.header.notificationReqInterval).subscribe(() => {
          if (this.authenticationService.loggedIn()) {
            
          }
        })
      }
    });
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.checkUserWalletForScaleUp();
  }

  checkUserWalletForScaleUp() {
    if (localStorage.getItem('LicenseExpired')) {
      this.isLicenseExpired = !!localStorage.getItem('LicenseExpired');
    }
    else {
      this.userService
        .checkForAutoscale(this.user, this.depName)
        .subscribe({
          next: (data: any) => {
            const { walletAmount } = data;

            if (walletAmount) {
              if (walletAmount <= 0) {
                this._snackBar.open("You Can not Scale UP As Wallet Balance is Zero", "Close", {
                  duration: 5000
                });
                this.dialog.close(false);
              }
              else {
                this.dialog.close(true);
              }
            }
            else {
              this._snackBar.open("You Can not Scale UP As Wallet Balance is Zero", "Close", {
                duration: 5000
              });
              this.dialog.close(false);
            }
          },
          error: (error: any) => {
            this._snackBar.open("Some error occurred!", "Close", {
              duration: 5000
            });
            this.dialog.close(false);
          }
        })
    }
  }
}
